'use client';
import { lazy, type ComponentProps } from 'react';
export type * from "/tmp/build-369/node_modules/@eliadmin/core/src/pages/search-advanced/page.tsx";
const Deferred0 = lazy(() => import("@eliadmin/page-island-original/419ed87f3a80").then(m => ({ default: m.default })));
const Island0 = ((props: NonNullable<ComponentProps<typeof import("/tmp/build-369/node_modules/@eliadmin/core/src/pages/search-advanced/page.tsx").default>>) => <Deferred0 {...props} />) as typeof import("/tmp/build-369/node_modules/@eliadmin/core/src/pages/search-advanced/page.tsx").default;
export default Island0;
